export default "__VITE_ASSET__7727cd16__"